import { render } from "./AddNiveauModal.vue?vue&type=template&id=49c7d5b8&ts=true"
import script from "./AddNiveauModal.vue?vue&type=script&lang=ts"
export * from "./AddNiveauModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__